import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";

import { cn } from "@/lib/ui/cn";

const badgeVariants = cva(
  "px-padding-element-md py-padding-element-2xs typography-text-medium-medium inline-flex items-center rounded-full border",
  {
    variants: {
      variant: {
        default: "bg-primary/10 text-primary border-transparent",
        outline: "border-border text-foreground",
        success: "bg-emerald-darkest text-emerald border-transparent",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
